import { useLocation, useNavigate } from "react-router-dom";

export const createScreenNavigationHandler = (navigate) => {
  return (path) => {
    if (path) {
      navigate(path);
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    }
  };
};

const useNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateWithParams = (url) => {
    navigate(url);
  };
  return {
    navigateWithParams,
  };
};
export default useNavigation;
